const host = process.env.VUE_APP_API_URL
export { host }
